import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03a09c1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "brand-list-item" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = { class: "info" }
const _hoisted_4 = { class: "name" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stats" }, null, -1))
const _hoisted_6 = { class: "link" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-right" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BrandPhoto = _resolveComponent("BrandPhoto")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_BrandPhoto, { brand: _ctx.brand }, null, 8, ["brand"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.brand.name), 1),
        _hoisted_5
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_router_link, {
        to: { name: 'brand', params: { brandID: _ctx.brand?.id } }
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Go to brand "),
          _hoisted_7
        ]),
        _: 1
      }, 8, ["to"])
    ])
  ]))
}